import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import AiTextGenerator from '../../../../UI/AiTextGenerator/AiTextGenerator'
import Button from '../../../../UI/Button/Button'
import Input from '../../../../UI/Input/Input'
import styles from './VacancyTemplateForm.module.scss'
import { useNotify } from '../../../../hooks/useNotify'
import { useDispatch, useSelector } from 'react-redux'
import { updateTemplate, postTemplate, setIsButtonEnable } from '../../../../redux/vacancyManager/vacancyManager.action'

const VacancyTemplateForm = () => {
  const [loading, setLoading] = useState(false)

  const { notify } = useNotify()
  const dispatch = useDispatch()
  const {
    vacancyType,
    templateType,
    inEditId: currentInEdit,
    landTemplateSalaryForm,
    seaTemplateSalaryForm,
    landTemplateDescriptionForm,
    seaTemplateDescriptionForm,
    isButtonEnable,
  } = useSelector(({ vacancies }) => vacancies)
  const fields = [`name_of_${templateType}`, templateType]

  const getFormByType = () => {
    if (vacancyType === 'land' && templateType === 'salary_description') {
      return landTemplateSalaryForm
    } else if (vacancyType === 'sea' && templateType === 'salary_description') {
      return seaTemplateSalaryForm
    } else if (vacancyType === 'land' && templateType === 'description') {
      return landTemplateDescriptionForm
    } else if (vacancyType === 'sea' && templateType === 'description') {
      return seaTemplateDescriptionForm
    }
    return {
      [`name_of_${templateType}`]: '',
      [templateType]: '',
      template_type: templateType,
      vacancy_type: vacancyType,
    }
  }

  const maxCharacters = templateType === 'description' ? 130 : 70

  const formik = useFormik({
    initialValues: getFormByType(),
    enableReinitialize: true,

    onSubmit: (values) => {
      if (currentInEdit) {
        dispatch(updateTemplate(values, currentInEdit, vacancyType, templateType))
      } else {
        dispatch(postTemplate(values, formik.resetForm, vacancyType, templateType))
      }
    },
  })
  const { values, errors, touched, handleSubmit, setFieldTouched, handleChange, dirty } = formik

  const handleValueChange = (e) => {
    const { name } = e.target
    if (!touched[name]) setFieldTouched(name, true)
    handleChange(e)
  }

  useEffect(() => {
    const errorsToNotify = []

    fields.forEach((field) => {
      if (touched[field] && errors[field]) {
        const isWithoutValue = !values[field] || Number(values[field]) <= 0

        if ((values[field].name && !values[field].id) || isWithoutValue) {
          errorsToNotify.push({ field, message: errors[field]?.id ?? errors[field] })
        }
      }
    })

    if (!errorsToNotify.length) return

    const content = errorsToNotify.map((item) => <p key={item.field}>{`Field "${item.field}" - ${item.message}`}</p>)

    notify('Form validation issue!', content, {
      type: 'warning',
    })

    // eslint-disable-next-line
  }, [errors, values])

  useEffect(() => {
    dispatch(setIsButtonEnable(dirty && !loading))
  }, [dirty, dispatch, loading])

  return (
    <form onSubmit={handleSubmit} className={styles.form}>
      <Input
        name={`name_of_${templateType}`}
        label={`Name Of Template`}
        onChange={handleValueChange}
        value={values[`name_of_${templateType}`]}
        isInvalid={errors[`name_of_${templateType}`] && touched[`name_of_${templateType}`]}
        errorMessage={errors[`name_of_${templateType}`]}
      />
      <AiTextGenerator
        currentInEdit={currentInEdit}
        formik={formik}
        name={templateType}
        value={values[templateType]}
        isInvalid={errors[templateType] && touched[templateType]}
        errorMessage={errors[templateType]}
        onChange={handleValueChange}
        textarea={true}
        maxCharacters={maxCharacters}
        requestParams={{
          filler_name: `${vacancyType}_vacancy_${templateType}`,
          message: values[templateType],
        }}
        setLoading={setLoading}
        loading={loading}
      />
      <Button type="submit" disabled={!isButtonEnable} className={styles.saveButton}>
        Save
      </Button>
    </form>
  )
}

export default VacancyTemplateForm
